<template lang="pug">
#app
  .sidebar
    sidebar
  .content
    .header
      navbar
        navbar-left(slot="left")
        navbar-right(slot="right")
    .body
      transition(name="slide-fade", mode="out-in")
        router-view
    .footer
      footer-component
</template>

<script>
import Navbar from "@/components/navegacao/Navbar"
import NavbarLeft from "@/components/navegacao/NavbarLeft"
import NavbarRight from "@/components/navegacao/NavbarRight"
import Sidebar from "@/components/navegacao/Sidebar"
import FooterComponent from "@/components/Footer"
import ApiInfoService from "@/lib/ApiInfoService"

export default {
  components: { Sidebar, Navbar, NavbarLeft, NavbarRight, FooterComponent },
  created() {
    ApiInfoService.fetchInfo()
  },
}
</script>

<style lang="stylus" scoped>
#app {
  display: flex;

  .sidebar {
    flex: 0;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;

    .header {
      flex: 0;
    }

    .body {
      flex: 1;
      overflow-y: auto;
      overflow-scrolling: touch;
      -webkit-overflow-scrolling: touch;
    }

    .footer {
      flex: 0;
    }
  }
}
</style>
